import React, { useState } from 'react';
import ReactTags from 'react-tag-autocomplete'
 
class Tag_input extends React.Component {
  constructor (props) {
    super(props)
 
    this.state = {
      tags: [
        { id: 1, name: "Offer" },
        { id: 2, name: "Active" }
      ],
      suggestions: [
        { id: 3, name: "Inactive" },
        { id: 4, name: "Interview" },
        { id: 5, name: "Assessment" },
        { id: 6, name: "Email" }
      ]
    }
  }
 
  handleDelete (i) {
    const tags = this.state.tags.slice(0)
    tags.splice(i, 1)
    this.setState({ tags })
  }
 
  handleAddition (tag) {
    const tags = [].concat(this.state.tags, tag)
    this.setState({ tags })
  }
 
  render () {
    return (
      <ReactTags
        tags={this.state.tags}
        suggestions={this.state.suggestions}
        handleDelete={this.handleDelete.bind(this)}
        handleAddition={this.handleAddition.bind(this)} />
    )
  }
}
export default Tag_input;